import { ReservedUserIds } from "./types";

export const filterReservedUserIds = (userIds: string[]): string[] =>
  userIds.filter(
    (id) => !Object.values(ReservedUserIds).includes(id as ReservedUserIds)
  );
